import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from './useAuth';
import type { ReactNode } from 'react';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { ready, tokens } = useAuth();
  const loc = useLocation();

  if (!ready) {
    return (
      <Box sx={{ minHeight: '50vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress size={24} />
      </Box>
    );
  }
  if (!tokens) {
    return <Navigate to={`/signin?from=${encodeURIComponent(loc.pathname)}`} replace />;
  }
  return <>{children}</>;
}
